<template>
    <div>
        <Form @submit="submit">
            <div v-for="item in action.paramList" :key="item.id">
                <Field v-if="item.dataType=='Boolean'"
                       v-model="form[item.code]"
                       :label="item.name"
                       required
                       :rules="getInputRules(item)"
                >
                    <RadioGroup
                            slot="input"
                            v-model="form[item.code]"
                            direction="horizontal"
                    >
                        <Radio name="true">{{item.booleanTrueValue}}</Radio>
                        <Radio name="false">{{item.booleanFalseValue}}</Radio>
                    </RadioGroup>
                </Field>
                <Field v-else-if="item.dataType=='Int'||item.dataType=='Float'"
                       v-model="form[item.code]"
                       clearable required
                       :label="item.name"
                       placeholder="请输入数字"
                       :rules="getInputRules(item)"
                       type="number"

                />
                <Field v-else-if="item.dataType=='Enum'"
                       v-model="form[item.code]"
                       clearable required
                       :label="item.name"
                       placeholder="请选择"
                       :rules="getInputRules(item)"
                       @click="enumPopup(item.code,item.enumItems)"


                />
                <Field v-else
                       v-model="form[item.code]"
                       clearable required
                       :label="item.name"
                       placeholder="请输入字符串"
                       :rules="getInputRules(item)"


                />
            </div>
            <Button round block type="info" native-type="submit">
                提交
            </Button>

        </Form>
        <SelectEnumPanel
                :data="enumData"
                :show="enumPanel.length>0?true:false"
                :type="enumPanel"
                @cancel="enumPopup"
                @ok="enumOk"
        />
    </div>
</template>

<script>
    import {Button, Checkbox, Field, Form, Radio, RadioGroup} from "vant"
    import SelectEnumPanel from "@/components/SelectEnumPanel";
    import {getInputRules} from "@/utils/rules"

    export default {
        components: {Form, Button, Field, RadioGroup, Radio, Checkbox, SelectEnumPanel},
        props: {
            action: {type: Object, default: {}},
            deviceId: {type: String, default: ''},
            defaultValue: {type: Object, default: {}},
        },
        data() {
            return {
                form: {},
                enumData: [], enumPanel: ''
            }
        },
        created() {
            const {defaultValue} = this
            Object.keys(defaultValue).map(key => {
                this.form[key] = defaultValue[key]
            })
            this.getLastActionParams()
        },
        computed: {},
        methods: {
            submit() {
                const {action, form,} = this
                const params = {actionId: action.id, actionCode: action.code, ...form}

                this.$emit('submit', action, params)
            },
            getLastActionParams() {
                this.$http.tokiot.device.getLastActionParams({id: this.deviceId, actionCode: this.action.code})
                    .then(ret => {
                        if (ret) {
                            // Object.keys(ret).map(key=>{
                            //     this.form[key]=this.form[key]||ret[key]
                            // })
                        }
                    })
            },

            enumPopup(show, data) {
                this.enumPanel = show ? show : "";
                const enumData = [];
                if (show) {
                    Object.keys(data).forEach(function (key) {
                        enumData.push({value: key, text: data[key]});
                    });
                }
                this.enumData = enumData;
            },
            enumOk(enumType, selected) {
                this.enumPanel = "";
                this.form[enumType] = selected.value;
                this.enums[enumType] = selected.text;
            },
            getInputRules

        },
        watch: {
            defaultValue(defaultValue) {
                if (defaultValue) {
                    Object.keys(defaultValue).map(key => {
                        this.form[key] = defaultValue[key]
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>